import React, { useEffect } from "react";
import "./VideoModal.css";

const VideoModal = ({ video, isOpen, onClose }) => {
  useEffect(() => {
    if (!isOpen) return;

    // Prevent background page from scrolling
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    // Close modal with Escape key
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, onClose]);

  if (!isOpen || !video) return null;

  return (
    <div className="modal-overlay" onClick={onClose} role="presentation">
      <div
        className="modal-content"
        onClick={(event) => event.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="video-modal-title"
      >
        <button
          type="button"
          className="modal-close"
          onClick={onClose}
          aria-label="Close project"
        >
          ×
        </button>

        <div className="video-container">
          <iframe
            src={video.videoUrl}
            title={video.title}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            loading="lazy"
          />
        </div>

        <div className="video-details">
          <h2 id="video-modal-title">{video.title}</h2>

          <p>{video.description}</p>

          <div className="video-details-meta">
            <span className="category">{video.category}</span>
            <span className="year">{video.year}</span>
            <span className="duration">{video.duration}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoModal;
